import { type ButtonHTMLAttributes, type ReactNode } from 'react';

export enum Colors {
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
    translucent = 'translucent',
    transparent = 'transparent',
    warning = 'warning',
    error = 'error',
    white = 'white',
    gradient = 'gradient',
    clear = 'clear',
}
export type Color = `${Colors}`;

export enum Variants {
    yat = 'yat',
    solid = 'solid',
    foggy = 'foggy',
    highlight = 'highlight',
}
export type Variant = `${Variants}`;

export type ButtonBaseProps = ButtonHTMLAttributes<HTMLElement> & {
    className?: string;
    indicatorValue?: number;
    to?: string;
    children?: ReactNode;
    disabled?: boolean;
    variant?: Variant;
    color?: Color;
};
